import { Component } from '@angular/core';

@Component({
  selector: 'app-pagina',
  templateUrl: './pagina.component.html'
})
export class PaginaComponent {

}
